
import { fas } from '@fortawesome/free-solid-svg-icons';
import Vue from 'vue'
import Component from 'vue-class-component';
import EventBus from './../../eventBus'

@Component
export default class ChangePassword extends Vue {
  // Data
  password = {
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: ""
  }
  nextURL: string = ''
  error: any = {
    generalMessage: '',
    errors: []
  }
  activeScreen: string = 'main'

  // methods
  onSubmit() {
    if (this.password.newPassword.length < 8) {
      //toast
      this.$bvToast.toast('Password length must be more than 8 characters', {
        title: 'Error',
        autoHideDelay: 10000,
        appendToast: true,
        toaster: 'b-toaster-bottom-right',
        solid: true,
        variant: 'danger'
      })
      return
    }

    if (this.password.newPassword != this.password.confirmNewPassword) {
      //toast
      this.$bvToast.toast('Passwords do not match', {
        title: 'Error',
        autoHideDelay: 10000,
        appendToast: true,
        toaster: 'b-toaster-bottom-right',
        solid: true,
        variant: 'danger'
      })
      return;
    }

    const payload = {
      password: this.password.newPassword,
      email: this.$route.query.email,
      token: this.$route.query.token
    }
    this.activeScreen = 'loading'
    EventBus.$emit('activeScreen', this.activeScreen)
    this.$store.dispatch("usersModule/changePassword", payload).then((response: any) => {
      this.$bvToast.toast('Your password has been updated successfully. Please login.', {
        title: 'Success',
        autoHideDelay: 10000,
        appendToast: true,
        toaster: 'b-toaster-bottom-right',
        solid: true,
        variant: 'danger'
      })
      this.$router.replace({ path: '/login' })
    }).catch((err: any) => {
      this.error.generalMessage = err.response.data.message
      this.activeScreen = "main"
      EventBus.$emit('activeScreen', this.activeScreen)
    });

  }

}
